import React from 'react'
import { useDispatch } from 'react-redux';
import { MediaBaseUrl } from '../../../../../../actions/api';
import { togglePlanSection_D } from '../../../../../../actions/showDisplayModalAction';

function UpgradePopup({ onHide }) {
    
    const dispatch = useDispatch();
 
    return (
        <div className="modal-content">
            <div className="modal-body">
                <button type="button" className="btn-close" onClick={onHide} data-bs-dismiss="modal" aria-label="Close" aria-hidden="true"></button>
                <div className="p-8">
                    <div className="pb-8 text-center">
                        <div className="Errorimage mb-10">
                            <img className="img-fluid" src={`${MediaBaseUrl}error/permission-error.svg`} />
                        </div>
                        <h3 className="text-center mb-5 ErrorMsg">Unable to make Full Screen Announcements?</h3>
                        <p className="font-weight-bold text-dark-75 text-center msgSec">Oops! Looks like you need to upgrade your plan in order to make Full Screen Announcements</p>
                    </div>
                    <div className="text-center">
                        <a href="javascript:;" className="btn btn-primary" onClick={() => dispatch(togglePlanSection_D(true))} data-bs-dismiss="modal" data-factors-click-bind="true">Upgrade Plan</a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UpgradePopup